import queryString from 'qs';

const getHostPromoListRequest = (queryParams) => {
  const queries = { limit: queryParams?.limit, page: queryParams?.page };

  if (queryParams?.search) queries.search = queryParams?.search;
  if (queryParams?.brandId) queries['brand.name'] = `[${queryParams?.brandId?.join(',')}]`;
  if (queryParams?.stockStatus) queries.statusStock = queryParams?.stockStatus;
  if (queryParams?.promoStatus) queries.status = `[${queryParams?.promoStatus?.join(',')}]`;
  if (queryParams?.store) queries['storeName'] = `[${queryParams?.store?.map((opt) => opt.value).join(',')}]`;

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getHostPromoListRequest;
